import { SVGProps, Ref, forwardRef } from "react";

const Logo = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    width="1em"
    height="1em"
    viewBox="0 0 161 38"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-label="Throttle Logo"
    {...props}
  >
    <path
      d="M19.0412 14.3844L16.719 29.0666H11.0528L13.3721 14.3844H8.40625L9.16117 9.63379H24.7591L24.0042 14.3844H19.0383H19.0412Z"
      fill="currentColor"
    />
    <path
      d="M36.6215 29.0637L37.8099 21.5604H31.36L30.1717 29.0637H24.5312L27.6084 9.63379H33.2487L32.1149 16.8386H38.5648L39.6986 9.63379H45.3648L42.2877 29.0637H36.6215Z"
      fill="currentColor"
    />
    <path
      d="M55.7347 9.63379C60.026 9.63379 62.9137 11.5512 62.9137 15.3833C62.9137 18.6756 61.1856 20.8887 58.4874 22.1029L61.1598 29.0666H55.3041L53.3867 23.0215H51.7936L50.8492 29.0666H45.3438L48.4208 9.63666H55.7347V9.63379ZM53.1714 14.3844L52.5227 18.5407H54.6267C55.9213 18.5407 57.1355 17.9466 57.1355 16.0836C57.1355 14.8436 56.2973 14.3844 55.2726 14.3844H53.1685H53.1714Z"
      fill="currentColor"
    />
    <path
      d="M74.1721 28.9229C74.0791 28.5868 70.0974 25.1317 69.752 21.7741C69.5739 20.0379 69.9983 18.3483 70.9833 16.9281L68.1569 12.728C65.6727 15.35 64.5639 18.7928 64.9324 22.375C64.9324 22.375 65.349 26.1662 68.1058 28.9229"
      fill="currentColor"
    />
    <path
      d="M80.3047 28.9229C80.3976 28.5868 84.3793 25.1317 84.7247 21.7741C84.9028 20.0379 84.4785 18.3483 83.4935 16.9281L86.3199 12.728C88.804 15.35 89.9129 18.7928 89.5443 22.375C89.5443 22.375 89.1277 26.1662 86.371 28.9229"
      fill="currentColor"
    />
    <path
      d="M76.5938 8.94068C74.6997 9.00882 72.8444 9.51525 71.0742 10.4476L73.3601 14.7329C75.4029 13.6689 77.839 13.6317 79.8446 14.4154L82.8646 10.3608C80.9426 9.19932 78.9386 8.85705 76.5938 8.94068Z"
      fill="currentColor"
    />
    <path
      d="M84.9142 10.6112L75.9752 21.0254C75.7386 21.2224 75.7035 21.5676 75.9049 21.7271L77.1054 22.6236C77.3068 22.7831 77.6352 22.6691 77.7719 22.394L85.5104 11.0833C85.7296 10.6457 85.2897 10.2964 84.9142 10.6096L84.9142 10.6112Z"
      fill="#2EAD6F"
    />
    <path
      d="M76.8742 23.6386C78.2053 23.6604 79.302 22.599 79.3238 21.2679C79.3456 19.9368 78.2842 18.8401 76.9531 18.8183C75.622 18.7965 74.5253 19.8579 74.5035 21.189C74.4817 22.5201 75.5431 23.6168 76.8742 23.6386Z"
      fill="#2EAD6F"
    />
    <path
      d="M115.875 14.3724L113.555 29.0425H107.893L110.26 14.3423H105.262L106.007 9.62695H121.592L120.836 14.3724H115.875Z"
      fill="currentColor"
    />
    <path
      d="M121.316 29.0425L124.392 9.62695H130.027L127.707 24.2971H134.341L133.585 29.0425H121.316Z"
      fill="currentColor"
    />
    <path
      d="M136.52 29.0425L139.595 9.62695H152.592L151.836 14.3724H144.474L144.07 16.962H150.379L149.678 21.41H143.369L142.91 24.2943H150.677L149.921 29.0397H136.52V29.0425Z"
      fill="currentColor"
    />
    <path
      d="M88.0273 9.58887C89.4736 10.8414 90.5597 12.6151 91.1873 14.4407H95.4906L92.9365 29.0726H98.8908L101.095 14.3424H105.989L107.009 9.58887H88.0301H88.0273Z"
      fill="currentColor"
    />
  </svg>
);

const ForwardRef = forwardRef(Logo);
export default ForwardRef;
